import type { SnapshotTag } from "@istari/istari-client";

import type { BranchId } from "~/branching/model/branch";
import type { BranchListItem } from "~/branching/model/branch-list-item";
import type { CommitId } from "~/branching/model/commit";

export function toBranchListItem(tag: SnapshotTag): BranchListItem {
  return {
    id: tag.id as BranchId,
    name: tag.tag,
    isDefault: tag.isBaseline,
    // Backend returns title-case ("Archived"/"Active"); normalize before compare.
    isArchived: tag.archiveStatus.toLowerCase() === "archived",
    headCommitId: tag.snapshotId as CommitId,
    isProtected: tag._protected ?? false,
  };
}
